import * as $ from 'jquery';
import { getCookie, setCookie } from "../../js/utils";

class CulturePopUp {
  init = () => {
    const cultureModal: HTMLButtonElement = document.querySelector('.resero-modal.resero-modal--culture-pop-up');
    
    if (!cultureModal) {
      return;
    }
    const delayTime = cultureModal.getAttribute('data-delay') ? cultureModal.getAttribute('data-delay') : 500;
    
    if(getCookie("cp_closed") === ""){
      setTimeout(function(){
        $('body').addClass('resero-modal-open');
        $(cultureModal).removeClass("resero-modal--hidden");
      }, Number(delayTime))
    }

    function handlePopUpClose () {
      setCookie("cp_closed", 'true', 30);
      $('body').removeClass('resero-modal-open')
      $(cultureModal).addClass("resero-modal--hidden");
    }

    $(".resero-modal__close:not('.resero-modal__custom-close'), .resero-modal__heading__desc a, .resero-modal__region__item .button:not('.-active')").on("click", handlePopUpClose);

  };

}

const CulturePopUpInstance = new CulturePopUp();
CulturePopUpInstance.init();

export { CulturePopUp, CulturePopUpInstance };